"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _atom = require("atom");

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _PromiseHandlers = require("UIComponents/core/PromiseHandlers");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UISearchableSelectInput = _interopRequireDefault(require("UIComponents/input/UISearchableSelectInput"));

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _PropertyOptionRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyOptionRecord"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _PropertyValueDisplay = require("customer-data-property-utils/PropertyValueDisplay");

var _ChangePipelineDialog = _interopRequireDefault(require("customer-data-objects-ui-components/deal/ChangePipelineDialog"));

var _immutable = require("immutable");

var _ObjectRecordAccessors = require("customer-data-objects/record/ObjectRecordAccessors");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _DealRecord = _interopRequireDefault(require("customer-data-objects/deal/DealRecord"));

var _Alerts = require("customer-data-ui-utilities/alerts/Alerts");

var _utils = require("reference-resolvers/utils");

var propTypes = {
  actions: _react.PropTypes.shape({
    onPipelineChange: _react.PropTypes.func
  }),
  className: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  onPipelineChange: _react.PropTypes.func,
  placeholder: _react.PropTypes.string,
  property: _react.PropTypes.instanceOf(_PropertyRecord.default).isRequired,
  readOnly: _react.PropTypes.bool.isRequired,
  resolver: _ReferenceResolverType.default.isRequired,
  subject: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_DealRecord.default), _react.PropTypes.instanceOf(_immutable.Map)]).isRequired,
  subjectId: _react.PropTypes.string,
  value: _react.PropTypes.node,
  'data-selenium-test': _react.PropTypes.string
};
var defaultProps = {
  readOnly: false,
  onPipelineChange: _emptyFunction.default,
  actions: {
    onPipelineChange: _emptyFunction.default
  }
};

var getPipelineOptions = function getPipelineOptions(pipelines) {
  return pipelines.sortBy(function (pipeline) {
    return pipeline.get('displayOrder');
  }).map(function (opt) {
    return (0, _PropertyOptionRecord.default)({
      displayOrder: opt.get('displayOrder'),
      label: opt.get('label'),
      value: opt.get('pipelineId') || opt.get('value')
    });
  }).toList();
};

var PropertyInputDealPipeline =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputDealPipeline, _React$Component);

  function PropertyInputDealPipeline() {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputDealPipeline);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputDealPipeline).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      pipeline: null,
      pipelines: null
    };
    return _this;
  }

  (0, _createClass2.default)(PropertyInputDealPipeline, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initReferenceAtom();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var newPipelineId = this.props.value;

      if (prevProps.value !== newPipelineId && !this.referenceAtomById) {
        this.initReferenceAtom();
      } else if (prevProps.value !== newPipelineId && this.referenceAtomById) {
        this.resetReferenceAtomById(newPipelineId);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.referenceAtomAll) {
        (0, _atom.unwatch)(this.referenceAtomAll, this.handlePipelinesReferenceChange);
      }

      if (this.referenceAtomById) {
        (0, _atom.unwatch)(this.referenceAtomById, this.handlePipelineReferenceChange);
      }
    }
  }, {
    key: "initReferenceAtom",
    value: function initReferenceAtom() {
      if (this.isNewDeal()) {
        this.referenceAtomAll = this.props.resolver.all();
        (0, _atom.watch)(this.referenceAtomAll, this.handlePipelinesReferenceChange);
        this.handlePipelinesReferenceChange((0, _atom.deref)(this.referenceAtomAll));
      } else if (this.props.value) {
        this.referenceAtomById = this.props.resolver.byId(this.props.value);
        (0, _atom.watch)(this.referenceAtomById, this.handlePipelineReferenceChange);
        this.handlePipelineReferenceChange((0, _atom.deref)(this.referenceAtomById));
      }
    }
  }, {
    key: "resetReferenceAtomById",
    value: function resetReferenceAtomById(newId) {
      (0, _atom.unwatch)(this.referenceAtomById, this.handlePipelineReferenceChange);
      this.setState({
        pipeline: null
      });
      this.referenceAtomById = this.props.resolver.byId(newId);
      (0, _atom.watch)(this.referenceAtomById, this.handlePipelineReferenceChange);
      this.handlePipelineReferenceChange((0, _atom.deref)(this.referenceAtomById));
    }
  }, {
    key: "handleAddError",
    value: function handleAddError() {
      return (0, _Alerts.addError)('ObjectsActions.alerts.alertUpdatePropertiesError');
    }
  }, {
    key: "handlePipelinesReferenceChange",
    value: function handlePipelinesReferenceChange(reference) {
      if (!(0, _utils.isResolved)(reference)) {
        return;
      }

      var pipelines = reference.map(function (_ref) {
        var pipeline = _ref.referencedObject;
        return pipeline;
      });
      this.setState({
        pipelines: pipelines
      });
    }
  }, {
    key: "handlePipelineReferenceChange",
    value: function handlePipelineReferenceChange(reference) {
      if (!(0, _utils.isResolved)(reference)) {
        return;
      }

      var pipeline = reference.referencedObject;

      if (!pipeline) {
        return;
      }

      this.setState({
        pipeline: pipeline
      });
    }
  }, {
    key: "isNewDeal",
    value: function isNewDeal() {
      return !this.props.subjectId;
    }
  }, {
    key: "handlePipelineChange",
    value: function handlePipelineChange(updates) {
      var _this$props = this.props,
          onPipelineChange = _this$props.onPipelineChange,
          subject = _this$props.subject;
      var pipeline = this.state.pipeline;
      var newPipelineId = updates.get('pipelineId');

      if (pipeline && // deals can be imported without pipelines
      newPipelineId !== pipeline.get('pipelineId')) {
        this.resetReferenceAtomById(newPipelineId);
      }

      var propertyUpdates = (0, _immutable.Map)({
        pipeline: updates.get('pipelineId'),
        dealstage: updates.get('stageId')
      });

      if (onPipelineChange === _emptyFunction.default) {
        return this.props.actions.onPipelineChange(subject, propertyUpdates, this.handleAddError);
      }

      return onPipelineChange(propertyUpdates);
    }
  }, {
    key: "handlePipelineEdit",
    value: function handlePipelineEdit(evt) {
      var _this$props2 = this.props,
          resolver = _this$props2.resolver,
          subject = _this$props2.subject;
      evt.preventDefault();
      return (0, _ChangePipelineDialog.default)({
        pipelineId: (0, _ObjectRecordAccessors.getProperty)(subject, 'pipeline'),
        stageId: (0, _ObjectRecordAccessors.getProperty)(subject, 'dealstage'),
        objectType: _ObjectTypes.DEAL,
        resolver: resolver
      }).then(this.handlePipelineChange, _PromiseHandlers.rethrowError).done();
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      return (0, _PropertyValueDisplay.makeOptionsFromPropertyWithoutBlankOptions)(this.props.property.set('options', getPipelineOptions(this.state.pipelines)));
    }
  }, {
    key: "renderPromptLink",
    value: function renderPromptLink() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          readOnly = _this$props3.readOnly;
      var pipeline = this.state.pipeline;
      return _react.default.createElement(_UIButton.default, {
        use: "form",
        onClick: this.handlePipelineEdit,
        className: className,
        disabled: readOnly
      }, pipeline && pipeline.get('label'));
    }
  }, {
    key: "renderDropdown",
    value: function renderDropdown() {
      if (!this.state.pipelines) {
        return _react.default.createElement("noscript", null);
      }

      var _this$props4 = this.props,
          className = _this$props4.className,
          onChange = _this$props4.onChange,
          placeholder = _this$props4.placeholder,
          value = _this$props4.value,
          readOnly = _this$props4.readOnly;
      var options = this.getOptions();
      var minNeededForDropdown = 2;
      return _react.default.createElement(_UISearchableSelectInput.default, {
        onChange: onChange,
        className: className,
        disabled: readOnly || options.length < minNeededForDropdown,
        options: options,
        value: "" + value,
        placeholder: placeholder,
        "data-selenium-test": this.props['data-selenium-test']
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.isNewDeal()) {
        return this.renderDropdown();
      }

      return this.renderPromptLink();
    }
  }]);
  return PropertyInputDealPipeline;
}(_react.default.Component);

PropertyInputDealPipeline.propTypes = propTypes;
PropertyInputDealPipeline.defaultProps = defaultProps;
var _default = PropertyInputDealPipeline;
exports.default = _default;
module.exports = exports.default;